module.exports = __webpack_public_path__ + "img/06d_Share_Persona.ea9145a9.jpg";